import { useEffect } from "react";

// New-tab landing for backdoor login. Reads the impersonation token from the URL
// hash (never sent to the server), stores it in this tab's sessionStorage only,
// strips the hash, and reloads into the app as the target account.
export default function ImpersonateLanding() {
  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/t=([^&]+)/);
    if (m) {
      const token = decodeURIComponent(m[1]);
      sessionStorage.setItem("wa_token", token);
      window.history.replaceState(null, "", "/");
      window.location.replace("/");
    } else {
      window.location.replace("/login");
    }
  }, []);
  return (
    <div className="min-h-screen grid place-items-center text-sm text-muted-foreground" data-testid="impersonate-landing">
      Opening account…
    </div>
  );
}
